import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IAuthToken } from 'utility-ng-auth-token';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Contact } from '../builders/contact_builder';

angular
  .module('capability-ng-resources')
  .factory(
    'loadContactsCommand',
    (defineCommand: IDefineCommand, authToken: IAuthToken, ngContactsDatastore: IDatasource<Contact>): ICommand => {
      return defineCommand('loadContactsCommand', (deferred: ng.IDeferred<IQuery[]>, studentId: string): void => {
        authToken
          .campusTokenRequest({
            url: `/api/students/${studentId}/support_team`,
            method: 'GET'
          })
          .then((response: any) => {
            ngContactsDatastore.write(response.team);
            ORM.run();
            deferred.resolve();
          })
          .catch((error: any) => {
            deferred.reject(error);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/commands/load_contacts_command.ts